import { Controller, useFormContext } from "react-hook-form";
import { Remove2faFormValues } from "../../types";
import { Stack, Text, View } from "@towersystems/roam-common-native";
import { useRemove2faStrategy } from "../../../../../../utilities/2fa/hooks";
import { OTPInput } from "../../../../../../components/OTPInput";

export interface EnterMfaCodeFieldsetProps {
  onComplete?: () => void;
}

export const EnterMfaCodeFieldset = ({
  onComplete,
}: EnterMfaCodeFieldsetProps) => {
  const formContext = useFormContext<Remove2faFormValues>();
  const { register, handleSubmit, control, formState } = formContext;
  const { errors, isValid, isDirty, isSubmitting } = formState;
  const isDisabled = !isValid || !isDirty || isSubmitting;

  const { handleOnSubmit } = useRemove2faStrategy();

  async function handleFinalSubmit(values: Remove2faFormValues) {
    return handleOnSubmit(values)?.then((success) => {
      if (success) {
        onComplete?.();
      }
    });
  }

  return (
    <Stack vertical>
      <View>
        <Text fontWeight="bold" variant="heading3">
          Enter MFA Code
        </Text>
        <Text>Please enter code from your chosen MFA method.</Text>
      </View>
      <View style={{ maxWidth: 300, width: "100%" }}>
        <Controller
          control={control}
          name="data.code"
          render={({ field: { onChange, value } }) => {
            let normalizedValue = value ? value : "";
            return (
              <OTPInput
                value={normalizedValue.split("")}
                onChange={(v) => {
                  onChange(v.join(""));
                }}
                length={6}
              />
            );
          }}
        />
      </View>
      {errors.root?.serverError && (
        <Text color="destructive">{errors.root?.serverError.message}</Text>
      )}
    </Stack>
  );
};
